module.exports = __webpack_public_path__ + "static/party_bn2@2x-db6924b578f2a1df6a88afb51e4f810d.png";